import OBase from './OBase';
import * as Geometry from '../geometry';
import * as GHMath from '../../math';
import Consts from '../../Consts';

export default class EFillet extends OBase {
  update () {
    let crvTree = this.getSurfaceObjectInput('C');
    let radTree = this.getFloatInput('R');

    let output;
    if ('S' in this.outputs) {
      output = this.getGenericObjectOutput('S');
    } else {
      // for old version of EFillet
      output = this.getGenericObjectOutput('fillet');
    }

    let dataTrees = [crvTree, radTree];
    let outDataTrees = [];

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();
    const rad2deg = (180 / Math.PI);

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let paths = outDataTrees[0].branches[i][j];
        let radius = outDataTrees[1].branches[i][j]; //* 0.5

        let newPaths = [];
        for (let k in paths) {
          let path = paths[k];
          let newPath = [];

          for (let t = 0; t < path.length; t++) {
            let rad = radius;
            let ratio = 0.99; // 0.49
            let pt = path[t];
            let pt1 = path[(t + path.length - 1) % path.length];
            let pt2 = path[(t + 1) % path.length];

            // pt1 = new ClipperLib.IntPoint(pt.X + (pt1.X - pt.X) * ratio, pt.Y + (pt1.Y - pt.Y) * ratio)
            // pt2 = new ClipperLib.IntPoint(pt.X + (pt2.X - pt.X) * ratio, pt.Y + (pt2.Y - pt.Y) * ratio)
            pt1 = new ClipperLib.DoublePoint(pt.X + (pt1.X - pt.X) * ratio, pt.Y + (pt1.Y - pt.Y) * ratio);
            pt2 = new ClipperLib.DoublePoint(pt.X + (pt2.X - pt.X) * ratio, pt.Y + (pt2.Y - pt.Y) * ratio);

            let pp1 = Math.sqrt(Math.pow(pt.X - pt1.X, 2) + Math.pow(pt.Y - pt1.Y, 2));
            let pp2 = Math.sqrt(Math.pow(pt.X - pt2.X, 2) + Math.pow(pt.Y - pt2.Y, 2));
            let min = Math.min(pp1, pp2);

            let angle = Math.atan2(pt.Y - pt1.Y, pt.X - pt1.X) - Math.atan2(pt.Y - pt2.Y, pt.X - pt2.X);
            if (angle < 0) {
              angle += Math.PI * 2;
            }

            let tempPP1Rad = pp1 * Math.abs(Math.tan(angle * 0.5));
            let tempPP2Rad = pp2 * Math.abs(Math.tan(angle * 0.5));
            rad = Math.min(rad, tempPP2Rad);
            rad = Math.min(rad, tempPP1Rad);

            let segment = rad / Math.abs(Math.tan(angle / 2));
            let pc1 = segment;
            let pc2 = segment;

            if (segment > min) {
              segment = min;
              rad = segment * Math.abs(Math.tan(angle / 2));
            }

            if (rad < 0.1) {
              newPath.push(pt);
            } else {
              let po = Math.sqrt(Math.pow(rad, 2) + Math.pow(segment, 2));

              let c1x = pt.X - (pt.X - pt1.X) * pc1 / pp1;
              let c1y = pt.Y - (pt.Y - pt1.Y) * pc1 / pp1;

              let c2x = pt.X - (pt.X - pt2.X) * pc2 / pp2;
              let c2y = pt.Y - (pt.Y - pt2.Y) * pc2 / pp2;

              let cx = c1x + c2x - pt.X;
              let cy = c1y + c2y - pt.Y;

              let dx = pt.X - cx;
              let dy = pt.Y - cy;

              let pc = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));

              let ox = pt.X - dx * po / pc;
              let oy = pt.Y - dy * po / pc;

              let startAngle = Math.atan2((c1y - oy), (c1x - ox));
              let endAngle = Math.atan2((c2y - oy), (c2x - ox));

              if (startAngle < 0) {
                startAngle += Math.PI * 2;
              }
              if (endAngle < 0) {
                endAngle += Math.PI * 2;
              }

              let sweepAngle = endAngle - startAngle;

              if (sweepAngle < 0) {
                sweepAngle += Math.PI * 2;
              }

              if (sweepAngle > Math.PI) {
                sweepAngle = sweepAngle - Math.PI * 2;
              }

              const degreeFactor = 10.0;
              let pointsCount = 1 + Math.ceil(Math.abs(sweepAngle * rad2deg / degreeFactor));

              for (let s = 0; s < pointsCount; s++) {
                let pointX = ox + Math.cos(startAngle + sweepAngle / (pointsCount - 1) * s) * rad;
                let pointY = oy + Math.sin(startAngle + sweepAngle / (pointsCount - 1) * s) * rad;

                // newPath.push(new ClipperLib.IntPoint(pointX, pointY))
                newPath.push(new ClipperLib.DoublePoint(pointX, pointY));
              }
            }
          }

          newPaths.push(newPath);
        }

        // console.log(newPaths)
        outTree.add(newPaths, outDataTrees[0].paths[i]);
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EFillet.js